module.exports = __webpack_public_path__ + "static/img/im.cf772c1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/im.gif
// module id = M86X
// module chunks = 0